import React from 'react';
import Button from '../../../../../components/Button';
import FixedBottomNavBar from '../../../../../components/FixedBottomNavBar';
import './AdminFormNavbar.scss';
import { FormMode } from '../../common/types/AccountAdminFormType';

interface IAdminFormNavbarProps {
  mode: FormMode;
}

const AdminFormNavbar = (props: IAdminFormNavbarProps): JSX.Element => {
  const { mode } = props;

  return (
    <FixedBottomNavBar className="admin-form-navbar">
      <div className="button-group">
        <Button
          color="primary"
          text={mode === 'detail' ? '편집하기' : '저장하기'}
          type="submit"
          form="account-admin-form"
        />
      </div>
    </FixedBottomNavBar>
  );
};

export default AdminFormNavbar;
